// Firebase Configuration
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyBLM-wJkWjxiqEnKcYHkyMDNhrla4L0hgw",
    authDomain: "interstrip-90486.firebaseapp.com",
    projectId: "interstrip-90486",
    storageBucket: "interstrip-90486.firebasestorage.app",
    messagingSenderId: "993913581840",
    appId: "1:993913581840:web:9b1b7f3c31efc68fc67595",
    measurementId: "G-4C34Y3M9E7"
};

// VAPID key for web push
const VAPID_KEY = 'BNJoB22oytAjt9kVSuXo2jMYr2LlZgC2G3J2qyVkgFFWAJRzeQF0H4w73VUTelRzZmjqPd6Z0wqAKGKqrAm_gko';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging = null;
try {
    messaging = getMessaging(app);
} catch (error) {
    console.warn('Firebase Messaging not supported in this browser:', error);
}

export { messaging, VAPID_KEY, getToken, onMessage };
